import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputRaZahlung } from './InputRaZahlung.entity';

export class InputRePaymentRelation<T extends EMode = EMode.entity> {
  /** Alias: add */
  add?: InputRaZahlung<T>[];
  /** Alias: delete */
  delete?: any[];
  /** Alias: modify */
  modify?: InputRaZahlung<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputRePaymentRelation> = {
  add: {
    alias: 'add',
  },
  delete: {
    alias: 'delete',
  },
  modify: {
    alias: 'modify',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputRePaymentRelationEntityDefinition: EntitiyDefinition<InputRePaymentRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputRePaymentRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
